import { useTranslation } from "react-i18next";
import * as yup from "yup";
export const publicCertificateDownloadSchema = () => {
  yup.setLocale({ string: {} });
  const { t } = useTranslation();
  return yup.object().shape({
    protocol: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
    gemi: yup
      .string()
      .matches(/^\d{12}$|^$/, t("Το πεδίο πρέπει να είναι αριθμός με 12 ψηφία"))
      .required(t("Το πεδίο είναι υποχρεωτικό")),
    "g-recaptcha-response": yup
      .string()
      .required(t("Παρακαλώ επιλέξτε το recaptcha")),
    d05_id: yup.number().required(t("Το πεδίο είναι υποχρεωτικό")),
  });
};
